import * as Api from '@utils/Api';
import { call, put } from 'redux-saga/effects';
import { types as installationsTypes } from '@reducers/installations';
import history from '../history';
import { getAccount } from './Account';

export function* fetchInstallations(action) {
  const { provider } = action;
  const response = yield call(Api.get, `${provider}/install`);
  if (!response.success) {
    yield put({
      type: installationsTypes.INSTALLATIONS_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
    });
    history.push('dash/settings/user/integrations');
  } else {
    yield put({
      type: installationsTypes.INSTALLATIONS_SUCCESS,
      provider,
      installations: response.data.installations,
    });
  }
}

export function* updateInstallation(action) {
  const { provider, providerId, allRepos, orgType, repositories } = action;
  const response = yield call(Api.post, `${provider}/install`, {
    providerId,
    allRepos,
    type: orgType,
    repositories,
  });
  if (!response.success) {
    yield put({
      type: installationsTypes.UPDATE_INSTALLATIONS_FAILURE,
      error: response.data ? response.data.error_message : 'Unknown error',
    });
  } else {
    yield getAccount();
    yield put({
      type: installationsTypes.UPDATE_INSTALLATIONS_SUCCESS,
      redirectUrl: response.data.url || '/dash',
    });
  }
}
